import { CircularProgress } from '@mui/material'

import { SplashContainer, SplashScreen, StyledText } from './styles'

const Splash = () => {
  return (
    <SplashScreen>
      <SplashContainer>
        <CircularProgress />
        <StyledText>Cargando...</StyledText>
      </SplashContainer>
    </SplashScreen>
  )
}

export default Splash
